import { SoStatusEnum } from '@gtpl/shared-models/common-models';
import { PlantIdRequest } from '@gtpl/shared-models/masters';
import { SoNumbersModel } from '@gtpl/shared-models/sale-management';
import { Repository, EntityRepository } from 'typeorm';
import { ProductIdRequest } from '../dto/product-id.request';
import { SaleOrder } from '../sale-order.entitiy';


@EntityRepository(SaleOrder)
export class SoRepository extends Repository<SaleOrder>{

    /**
     *
     * @param SaleOrderId the po id
     */
    async getSoData(soId: number): Promise<any> {
        const soEntity = this.createQueryBuilder("SaleOrder")
        .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
       
        // const plieDetails = await this.createQueryBuilder('purchase_order')
        //     .select('purchase_order_id,vendor_name,total_quantity,total_basic_price,total_discount,total_tax,total_cost')
        //     .leftJoin('purchase_order.purchase_order_id', 'purchase_order_items')
        //     .where(` purchase_order.purchase_order_id= '${poId}' `)
            .getOne();
            // console.log(poEntity)
        return soEntity ;
    }


    async getSaleOrdersForProduct(inputReq: ProductIdRequest): Promise<SoNumbersModel[]> {
        const soEntities:SoNumbersModel[] =await this
        .createQueryBuilder('SaleOrder')
        .select('SaleOrder.sale_order_id as saleOrderId, SaleOrder.sale_order_no as saleOrderNumber')
        .leftJoin('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        .leftJoin('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where('SaleOrder.status IN (:...status)', { status: [`${SoStatusEnum.OPEN}`, `${SoStatusEnum.IN_PROGRESS}`] })
        .andWhere(`saleOrderItemsInfo.item_id ='${inputReq.productId}' and SoInvDetailsInfo.unit ='${inputReq.plantId}' `)
        .groupBy('saleOrderItemsInfo.sale_order_id')
        .orderBy("SoInvDetailsInfo.edlDate", "ASC").getRawMany();
        if(soEntities&&soEntities.length){
            if(soEntities[0].saleOrderId){
                return soEntities;
            }else{
                return [];
            }
        }else{
            return [];
        }
    }


    /**
     * To get sale order number
     * @Param SaleOrderId 
     */
    async getSaleOrderNo(soId: number): Promise<string> {
        const soDetails = await this.findOne({select: ['saleOrderNumber'], where: {saleOrderId: soId}});
        return soDetails ? soDetails.saleOrderNumber: null;
    }

    /**
     * 
     * @returns so information for documents upload
     */
    async getDocInfo(plantIdRequest:PlantIdRequest,req:any[]): Promise<any> {
        console.log(req);
        let ids = []
        for(const rec of req){
            ids.push(rec.soIds)
        }
       if(plantIdRequest.unitcodeId != 5){
        const soEntity = this.createQueryBuilder("SaleOrder")
        .leftJoinAndSelect('SaleOrder.docUpInfo', 'docUpInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where("SoInvDetailsInfo.unit = "+ plantIdRequest.unitcodeId)
        .andWhere("SoInvDetailsInfo.saleOrderId IN ("+ids + ")")
        .orderBy("SaleOrder.created_at","DESC")
        .getMany();
        return soEntity;
       } else{
        const soEntity = this.createQueryBuilder("SaleOrder")
        .leftJoinAndSelect('SaleOrder.docUpInfo', 'docUpInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where("SoInvDetailsInfo.saleOrderId IN ("+ ids + ")")
        .orderBy("SaleOrder.created_at","DESC")
        .getMany();
        return soEntity;
       }
       
    }
   
    async getSaleOrderFewDetailsForSoId(soId: number){
        const soEntity = await this.createQueryBuilder("SaleOrder")
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where('SaleOrder.sale_order_id='+soId)
        .getOne();
        return soEntity;
    }
    
}
